// src/app/modules/Devices/components/ui.jsx
// Small presentational pieces shared across the Devices module.

import React from 'react';
import { Modal } from 'react-bootstrap';
import { RefreshCw, X } from 'lucide-react';

export const Pill = ({ tone = 'neutral', children, title }) => (
  <span className={`dv-pill dv-pill--${tone}`} title={title}>{children}</span>
);

export const Spinner = ({ size = 16 }) => <RefreshCw size={size} className="dv-spin" aria-label="Loading" />;

export const EmptyState = ({ icon: Icon, title, children, action }) => (
  <div className="dv-empty">
    {Icon && <div className="dv-empty__icon"><Icon size={22} /></div>}
    <h3>{title}</h3>
    {children && <p>{children}</p>}
    {action}
  </div>
);

export const Stat = ({ label, value, tone, icon: Icon }) => (
  <div className="dv-stat">
    {Icon && <span className={`dv-stat__icon dv-stat__icon--${tone || 'brand'}`}><Icon size={16} /></span>}
    <div>
      <div className="dv-stat__value">{value}</div>
      <div className="dv-stat__label">{label}</div>
    </div>
  </div>
);

export const Fact = ({ label, children }) => (
  <div className="dv-fact">
    <dt>{label}</dt>
    <dd>{children}</dd>
  </div>
);

/** Consistent modal shell: title, body, footer actions. */
export const DvModal = ({ show, onHide, title, subtitle, children, footer, size }) => (
  <Modal show={show} onHide={onHide} centered size={size} dialogClassName="dv-modal">
    <div className="dv-modal__head">
      <div>
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
      </div>
      <button type="button" className="dv-icon-btn" onClick={onHide} aria-label="Close"><X size={16} /></button>
    </div>
    <div className="dv-modal__body">{children}</div>
    {footer && <div className="dv-modal__foot">{footer}</div>}
  </Modal>
);

export const Button = ({ variant = 'secondary', size, icon: Icon, loading, children, className = '', ...rest }) => (
  <button
    type="button"
    className={`dv-btn dv-btn--${variant}${size ? ` dv-btn--${size}` : ''} ${className}`}
    disabled={loading || rest.disabled}
    {...rest}
  >
    {loading ? <Spinner size={14} /> : Icon && <Icon size={14} />}
    {children}
  </button>
);
